export default __webpack_public_path__ + "static/media/logo-text.2e726543.svg";